var _circle, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeDevice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 21,
    viewBox: "0 0 7 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 17.5,
    r: 3.5,
    fill: "#0066FF"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 3.5,
    x2: 3.5,
    y2: 16,
    stroke: "#0066FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeDevice);
export default __webpack_public_path__ + "static/media/home-device.c18bd6232937314271d523a386622bec.svg";
export { ForwardRef as ReactComponent };